const pillars = [
    {
        icon: "📍",
        title: "Proximité",
        desc: "Un interlocuteur local, joignable, qui comprend votre contexte. Pas une agence anonyme à l'autre bout du pays.",
    },
    {
        icon: "🤝",
        title: "Disponibilité",
        desc: "Réactivité garantie. On répond vite, on avance vite. Votre projet n'attend pas dans une file d'attente.",
    },
    {
        icon: "✨",
        title: "Qualité",
        desc: "Des applications fiables, rapides, modernes. Du code propre, des interfaces soignées, un résultat professionnel.",
    },
    {
        icon: "💰",
        title: "Prix juste",
        desc: "Un tarif honnête, sans surprises. Pas de coûts cachés, pas de sur-facturation. Le meilleur rapport qualité-prix.",
    },
];

export function Pillars() {
    return (
        <section id="atouts" className="scroll-mt-20 py-10 px-6 bg-[#eef3f9]">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-3xl sm:text-4xl font-bold text-center text-[#1a3660] mb-4">
                    Pourquoi choisir <span className="text-[#f07020]">appitep</span>&nbsp;?
                </h2>
                <p className="text-slate-500 text-center max-w-2xl mx-auto mb-10">
                    Quatre engagements qui font la différence pour chaque projet.
                </p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {pillars.map((p) => (
                        <div
                            key={p.title}
                            className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-md hover:border-[#f07020]/30 transition-all"
                        >
                            <div className="flex items-center gap-3 mb-2">
                                <span className="text-4xl">{p.icon}</span>
                                <h3 className="text-xl font-bold text-[#1a3660]">{p.title}</h3>
                            </div>
                            <p className="text-slate-500 leading-relaxed text-sm">{p.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
